class LanguageDropdown {
    constructor(selector = '.dropdown-select-lang') {
        this.container = document.querySelector(selector);
        if (!this.container) return;

        this.button = this.container.querySelector('.btn-lang');
        this.menu = this.container.querySelector('.list-lang');
        if (!this.button || !this.menu) return;

        this.items = this.menu.querySelectorAll('[role="menuitem"]');

        this.bindEvents();
    }

    bindEvents() {
        this.button.addEventListener('click', (e) => this.toggle(e));

        this.items.forEach((item) => {
            item.addEventListener('click', (e) => this.onItemClick(e));
        });

        document.addEventListener('click', (e) => this.onClickOutside(e));
    }

    open() {
        this.container.classList.add('is-open');
        this.menu.classList.remove('invisible', 'max-h-0', 'hidden');
        this.button.setAttribute('aria-expanded', 'true');
        this.items[0]?.focus();
    }

    close() {
        this.container.classList.remove('is-open');
        this.menu.classList.add('invisible', 'max-h-0', 'hidden');
        this.button.setAttribute('aria-expanded', 'false');
    }

    toggle(e) {
        e.preventDefault();
        e.stopPropagation();

        const expanded = this.button.getAttribute('aria-expanded') === 'true';
        expanded ? this.close() : this.open();
    }

    onItemClick(e) {
        e.preventDefault();
        this.selectLanguage(e.currentTarget);
    }

    onClickOutside(e) {
        // 🔒 BLOQUEIA SE MODAL ESTIVER ABERTO
        if (document.querySelector('.modal-busca.active')) return;

        if (!this.container.contains(e.target)) {
            this.close();
        }
    }

    selectLanguage(item) {
        const lang = item.dataset.lang;
        const href = item.getAttribute('href');

        if (href) {
            window.location.href = href;
            return;
        }

        const hrefLang = document.querySelector(`link[data-lang="${lang}"]`);
        if (hrefLang) {
            window.location.href = hrefLang.getAttribute('href');
        } else if (lang === 'pt_BR') {
            window.location.href = base_url;
        } else {
            window.location.href = `${base_url}${lang}`;
        }
    }
}

const initLanguageDropdown = () => {
    new LanguageDropdown();
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLanguageDropdown);
} else {
    initLanguageDropdown();
}
